<template>
    <div>
          <div class="row" v-if="project['interdisciplinar']">
                <div v-if='editable' style="text-align: right; padding-right:20px">
                    <button type='button' id="colaboradores" class="btn" @click='adicionarColab()'>
                        <i class="material-icons right">add</i>Colaborador
                    </button>
                </div>
				<div v-for="(collaborator, i) in collaborators" :key="collaborator.id" >
					<fieldset>
                        <div class="row">
                            <div class="input-field col s12 m3 l3 xl3">
                                <input 
                                    :disabled="!editable" :id="'col_cpf[' + i + ']'" 
                                    :name="'col_cpf[' + i + ']'" v-model='collaborator.user.cpf' type="text"
                                    class="validate" @input="onKeyUpCPF(i)" maxlength="11"
                                    v-bind:class="{ 'red-text': collaborator.user.cpf.length != 11, 'green-text': collaborator.user.cpf.length == 11 }"
                                    required
                                >
                                <label class='active' :for="'col_cpf[' + i + ']'">
                                    CPF <small>(somente números)</small>
                                </label>
                            </div>
                            <div class="input-field col s12 m3 l3 xl3">
                                <input :id="'col_nome[' + i + ']'" :name="'col_nome[' + i + ']'"
                                    v-model='collaborator.user.name' type="text" disabled required>
                                <label class='active' :for="'col_nome[' + i + ']'">Nome</label>
                            </div>
                            <div class="input-field col s12 m3 l3 xl3">
                                <input :id="'col_email[' + i + ']'" :name="'col_email[' + i + ']'" v-model='collaborator.user.email' type="email" disabled required>
                                <label class='active' :for="'col_email[' + i + ']'">E-mail</label>
                            </div>
                            <div class="input-field col s12 m3 l3 xl3">
                                <input :id="'col_social[' + i + ']'" :name="'col_social[' + i + ']'" v-model='collaborator.user.nome_social' type="text" disabled>
                                <label class='active' :for="'col_social[' + i + ']'">Nome social</label>
                            </div>
						</div>
						<div class="row">
                            <div class="input-field col s12 m3 l3 xl3">
                                <input :id="'col_centro[' + i + ']'" :name="'col_centro[' + i + ']'" v-model='collaborator.user.unidade.centro.nome' type="text" disabled required>
                                <label class='active' :for="'col_centro[' + i + ']'">Centro</label>
                            </div>
                            <div class="input-field col s12 m3 l3 xl3">
                                <input :id="'col_unidade[' + i + ']'" :name="'col_unidade[' + i + ']'" v-model='collaborator.user.unidade.nome' type="text" disabled required>
                                <label class='active' :for="'col_unidade[' + i + ']'">Unidade</label>
                            </div>
                            <div v-if="editable" class="file-field input-field col s12 m3 l3 xl3">
                                <div class="btn">
                                    <span>Lattes</span>
                                    <input type="file" :id="'/col-lattes/pdf/'+user.id+'/'+collaborator.user.cpf" 
                                    required accept="application/pdf">
                                </div>
                                <div class="file-path-wrapper">
                                    <input v-if='collaborator.user.email' 
                                    class="file-path validate" :id="'col_lattes[' + i + ']'" 
                                    type="text" >
                                    <input v-else class="file-path validate" :id="'col_lattes[' + i + ']'" type="text">
                                </div>
                            </div>
                            <div class="input-field col s12 m2 l2 xl2">
                                <label>
                                    <a v-if='collaborator.user.cpf' :class="'col_lattes_' + i" 
                                    :id="'/col-lattes/link-pdf/' + collaborator.user.cpf" 
                                    :href="'/col-lattes/pdf/' + user.id + '/' + collaborator.user.cpf" 
                                    target='_blank'>Ver PDF</a>
                                    <a v-else :class="'col_lattes_' + i" 
                                    :id="'/col-lattes/link-pdf/' + collaborator.user.cpf" 
                                    :href="'/col-lattes/pdf/' + user.id + '/' + collaborator.user.cpf"
                                     target='_blank'></a>
                                </label>
                            </div>
                            <div class="input-field col s12 m1 l1 xl1" v-show='collaborator.user.email && editable'>
                                <button  type='button' class="waves-effect waves-light btn blue" @click='remove(i)'>
                                    <i class="material-icons">delete</i>
                                </button>
                            </div>
						</div>
                    </fieldset>
				</div>
			</div>
    </div>
</template>
<script>
import {validatePDF,verifyCpf,getNamePdf} from '../../utils.js';
import { mapState, mapActions } from 'vuex';
export default {
    name:'Colaborador',
    props:[
        'editable',
        
    ],
    components:{
        validatePDF,verifyCpf,getNamePdf
    },
    computed:{
       ...mapState(['project']),
       collaborators(){
           return this.project.colaboradores;
       },
       user(){
           return this.project.curriculo.usuario;
       }
        
    },
   methods:{
        verifyCpf:verifyCpf,
        validatePDF:validatePDF,
        getNamePdf,
        ...mapActions(['setProject']),
        adicionarColab() {
            let colab = {};
            let user={};
            user.cpf = '';
            user.name = '';
            user.email = '';
            user.nome_social = '';
            user.unidade = {};
            user.unidade.id = '';
            user.unidade.centro = {};
            user.unidade.centro.id = '';
            colab.user=user;
            this.project.colaboradores.push(colab);
            this.setProject(this.project);
            this.$nextTick();
                
        },
        onKeyUpCPF(i){
            this.verifyCpf(this.project.colaboradores[i],this.user,this.project.colaboradores, i)
            .then( ()=>{
                this.setProject(this.project);
                this.$nextTick();
                
                
            });
           
            
            
        },
        remove(i){
            this.project.colaboradores.splice(i,1);
            this.setProject(this.project);
            this.$nextTick();
        }
    }
}
</script>